export default {
    car_00001: "Ingrese el nombre del grupo",
    car_00002: "EV",
    car_00003: "Generar y agrupar tarjetas plug-and-play",
    car_00004: "Agregar EV",
}